import Vue from "vue";
import Vuex from "vuex";
import modules from './modules'
import createPersistedstate from 'vuex-persistedstate'

Vue.use(Vuex);

function getPersistKey() {
  const hash = window.location.hash;
  const match = hash.match(/^#\/(home|auto)\/([^/?]+)/);
  const code = match ? match[2] : '';
  
  if (code) {
    return `weidun_store_${code}`;
  }
  
  const savedCode = sessionStorage.getItem('__weidun_code__');
  if (savedCode) {
    return `weidun_store_${savedCode}`;
  }
  
  return 'weidun_store_default';
}

export default new Vuex.Store({
  modules,
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  plugins:[
    createPersistedstate({
      storage: window.localStorage,
      key: getPersistKey(),
      paths: ['user','mobile','message','aiConfig','agent','history','channel']
    }) 
  ]
});
